import {
  Component,
  OnInit,
  ViewChildren,
  HostListener,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  QueryList,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { SelectedBankQuestionsService } from "./../../services/selected-bank-questions.service";
import { SourceInfoService } from "../../../shared/services/source-info.service";
import { ShareDataService } from "../../services/shared.service";
import { AutoUnsubscribe } from "./../decorator/autoUnsubscribe.decorator";
import { Subscription } from "rxjs";
import { HeaderData } from "../../models/header-items";
import { ButtonType } from "../button/button-type";
import { ButtonPurpose } from "../button/button-purpose";
import { SourceInfoData } from "./source-picker.model";
import { TooltipDirective } from "../tooltip";

@Component({
    selector: "source-picker",
    templateUrl: "./source-picker.component.html",
    styleUrls: ["./source-picker.component.scss"],
    standalone: false
})

// @AutoUnsubscribe(["sourceInfoSubscription","selectedBankSubscription"])
export class SourcePickerComponent implements OnInit {
  private error;
  headerData: HeaderData;
  checkedBank = -1;
  plusMinusSign = -1;
  focusedIndex: number;
  selectedBankObj: any;
  combinedBankNQuestionObj: any;
  questionList: any;
  sourceInfoData: SourceInfoData = {} as SourceInfoData;
  initialEvent = {};
  useSourceSuccess: boolean = false;
  screenHeight: number = null;
  screenWidth: number = null;
  selectedBankSubscription: Subscription;
  sourceInfoSubscription: Subscription;
  viewBankInfoData: any;
  showBankInfo = false;
  bankTitle: any;
  sourcePickerCompHeight: number = null;
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;
  private testIsbn: String;
  private _autoFocus: boolean = false;
  private treeItemsSubscription: Subscription;
  rootFolderIndex = 0;
  myQuestionsIndex = -2;
  bankInfoDisplayData: Array<{ label: string; value: any }> = [];
  constructor(
    private sourceInfoService: SourceInfoService,
    private sourceBankQuestion: SelectedBankQuestionsService,
    private router: Router,
    private shareDataService: ShareDataService,
    private cdr: ChangeDetectorRef
  ) {
    this.onResize();
  }

  @ViewChildren("mySelectedBank") item;
  @ViewChildren('treeitem') treeItems: QueryList<ElementRef>;
  @ViewChildren(TooltipDirective) tooltipDirective:  QueryList<TooltipDirective>;
  @Output() questionFlagSelect = new EventEmitter<boolean>();
  @Output() cancelButtonSelect = new EventEmitter<boolean>();
  @Output() sourceSuccess = new EventEmitter<boolean>();
  @Output() focusedElement = new EventEmitter<HTMLElement>();
  @Input("truncate-Title") truncateTitle;
  @Input() addQuestionHeaderId: string;
  products = [];
  selectedBanks = [];
  
  @Input()
  set autoFocus(value: boolean) {
    this._autoFocus = value;
  }

  ngAfterViewInit() {
    // This waits for the DOM elements to be ready
    this.treeItemsSubscription = this.treeItems.changes.subscribe(() => {
      if (this._autoFocus) {
        this.focusFirstTreeItemIfReady();
      }
    });
  }

  ngOnDestroy() {
    // Unsubscribe from the changes Observable
    if (this.treeItemsSubscription) {
      this.treeItemsSubscription.unsubscribe();
    }
  }

  private focusFirstTreeItemIfReady() {
    if (this.treeItems && this.treeItems.length > 0) {
      requestAnimationFrame(() => {
        this.setFocusedIndex(this.rootFolderIndex);
        this._autoFocus = false;
      });
    }
  }

  OnCheckboxSelect(bank, bankName: String, event, index: number) {
    this.checkedBank = index;
    this.selectedBankObj = bank;
    this.shareDataService.setBankName(bankName);
    setTimeout(function () {
      //do nothing
    }, 50);
  }

  public dblClickBank(bank, event, index) {
    this.OnCheckboxSelect(bank, bank.title, event, index);
    this.selectBank();
  }

  OnBankInfoSelect(show: boolean, bankId: String, bankTitle: String, virtualBankId?: number) {
    this.bankTitle = bankTitle;
    if (bankId != undefined) {
      this.sourceInfoService.viewBankInfo(bankId, virtualBankId).subscribe(
        (data) => {
          this.viewBankInfoData = data;
          this.showBankInfo = show;
          this.bankInfoDisplayData = this.transformBankInfoData(this.viewBankInfoData);
        },
        (error) => {
          this.error = error;
        }
      );
    }
  }

  private transformBankInfoData(data: any): Array<{ label: string; value: any }> {
    if (!data) return [];

    return Object.keys(data)
      .map(key => ({
        label: this.getLabel(key),
        value: data[key]
      }))
      .filter(item => item.label !== null);
  }

  hideBankInfo(show: boolean) {
    this.showBankInfo = show;
    this.viewBankInfoData = undefined;
  }

  readonly questionTypeLabels: Record<string, string> = {
    'Algo_count': 'Algorithm',
    'MC_count': 'Multiple Choice',
    'TF_count': 'True False',
    'FB_count': 'Fill in the Blank',
    'CA_count': 'Check all that apply',
    'SA_count': 'Short Answer',
    'ES_count': 'Essay',
    'SB_count': 'Section Break'
  };

  // Helper method to get label
  getLabel(key: string): string | null {
    return this.questionTypeLabels[key] || null;
  }

  ngOnInit() {
    this.sourceInfoSubscription = this.sourceInfoService
      .getSourceInfoCollection()
      .subscribe(
        (data) => {
          this.sourceInfoData = data;
          this.shareDataService.setSourceInfoDataList(data.sourceInfo);
        },
        (error) => {
          this.error = error;
        }
      );
    this.headerData = this.shareDataService.getHeaderData();
    // Set focus to root folder by default
    this.focusedIndex = 0;
  }

  @HostListener("window:resize", ["$event"])
  private onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.sourcePickerCompHeight = this.screenHeight - 367;
  }

  private getQuestionList() {
    this.questionFlagSelect.emit(true);
    const requestParam: any = { ezid: this.selectedBankObj.ezid };
    const release = localStorage.getItem("release");
    if (release) {
      requestParam['release'] = release;
    }
    if (this.selectedBankObj.virtualBankId) {
      requestParam['virtualBankId'] = this.selectedBankObj.virtualBankId;
    }
    this.selectedBankSubscription = this.sourceBankQuestion
      .SelectedBankQuestions(requestParam)
      .subscribe((data) => {
        this.questionList = data;
        this.combinedBankNQuestionObj = {
          bank: this.selectedBankObj,
          questions: this.questionList,
        };
        this.shareDataService.setBankObject(this.combinedBankNQuestionObj);
        this.useSourceSuccess = false;
        this.sourceSuccess.emit(this.useSourceSuccess);
      });
  }
  selectBank() {
    let bankTitle = this.selectedBankObj.title;
    this.testIsbn = this.shareDataService.getcheckISBN();
    if (
      this.testIsbn != undefined &&
      this.testIsbn != localStorage.getItem("isbn")
    ) {
      if (bankTitle != "My Questions") {
        this.sourceInfoService.getSourceInfoCollection(this.testIsbn).subscribe(
          (data) => {
            if (data && data["sourceInfo"]) {
              const sourceInfo = data["sourceInfo"];
              const message = {
                Message:
                  "Only questions from this title: " +
                  sourceInfo["isbn_title"] +
                  ", edition: " +
                  sourceInfo["edition"] +
                  " can be added to this test.",
              };
              this.shareDataService.sendMessageData(message);
            }
          },
          (error) => {
            this.error = error;
          }
        );
      } else {
        if (this.selectedBankObj) {
          this.getQuestionList();
        }
      }
    } else {
      if (this.selectedBankObj) {
        this.getQuestionList();
      }
    }
    this.focusedElement.emit(null);
  }
  public hideLeftPanel() {
    this.cancelButtonSelect.emit(true);
  }

  // --- Tree Navigation ---
  toggleFolder(): void {
    // Collapse (1) or Expand (0), retain -1 as open on first render
    this.plusMinusSign = this.plusMinusSign === 1 ? 0 : 1;
  }

  onTreeItemFocus(index: number, element: HTMLElement): void {
    this.focusedIndex = index;
    this.focusedElement.emit(element);
  }

  /**
   * Handles keyboard navigation and actions for tree items in the source picker component.
   *
   * This method processes keydown events for both folder and bank items, enabling keyboard accessibility.
   * It supports navigation with arrow keys, selection with Enter/Space, and jumping to the first/last item with Home/End.
   *
   * - ArrowDown: Moves focus to the next item.
   * - ArrowUp: Moves focus to the previous item.
   * - ArrowRight: Expands or navigates into a folder/bank.
   * - ArrowLeft: Collapses or navigates out of a folder/bank.
   * - Enter/Space: Selects or activates the focused item.
   * - Home: Moves focus to the root folder.
   * - End: Moves focus to the "My Questions" item if it exists; otherwise, focuses the root folder.
   *   (This allows users to quickly jump to the last actionable item in the tree.)
   * - Tab (on bank): Sets the info button as focused.
   *
   * @param event The keyboard event triggered by user interaction.
   * @param index The index of the currently focused item.
   * @param type The type of the item ('folder' or 'bank') being interacted with.
   */
  onTreeKeydown(event: KeyboardEvent, index: number, type: 'folder' | 'bank'): void {
    const banksLength = this.sourceInfoData?.sourceInfo?.banks?.length || 0;
    const { key } = event;

    // Prevent default and stop propagation for all handled keys
    if (['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Enter', ' ', 'Home', 'End'].includes(key)) {
      event.preventDefault();
      event.stopPropagation();
    }

    switch (key) {
      case 'ArrowDown':
        this.handleArrowDown(index, type, banksLength);
        break;

      case 'ArrowUp':
        this.handleArrowUp(index, type, banksLength);
        break;

      case 'ArrowRight':
        this.handleArrowRight(index, type, banksLength);
        break;

      case 'ArrowLeft':
        this.handleArrowLeft(index, type);
        break;

      case 'Enter':
      case ' ':
        this.handleEnterOrSpace(index, type, event);
        break;

      case 'Home':
        this.setFocusedIndex(this.rootFolderIndex);
        break;

      case 'End':
        if (this.sourceInfoData?.sourceInfo?.myquestions) {
          this.setFocusedIndex(this.myQuestionsIndex);
        } else {
          this.setFocusedIndex(this.rootFolderIndex);
        }
        break;

    }
  }

  private handleArrowDown(index: number, type: 'folder' | 'bank', banksLength: number): void {
    // If folder is expanded and at folder, move to first bank
    if (index === 0 && this.plusMinusSign !== 1 && banksLength > 0) {
      this.setFocusedIndex(1);
      return;
    }

    // If on a bank and not last bank, move to next bank
    if (type === 'bank' && index < banksLength) {
      this.setFocusedIndex(index + 1);
      return;
    }

    // If on last bank, move to My Questions
    if (type === 'bank' && index === banksLength) {
      this.setFocusedIndex(this.myQuestionsIndex);
      return;
    }

    // If folder is collapsed or no banks, move to My Questions
    if (index === 0 && (this.plusMinusSign === 1 || banksLength === 0)) {
      this.setFocusedIndex(this.myQuestionsIndex);
      return;
    }
  }

  private handleArrowUp(index: number, type: 'folder' | 'bank', banksLength: number): void {
    if (index === this.myQuestionsIndex) {
      // From My Questions: if banks exist and folder is expanded, go to last bank; else go to folder
      if (banksLength > 0 && this.plusMinusSign !== 1) {
        this.setFocusedIndex(banksLength);
      } else {
        this.setFocusedIndex(this.rootFolderIndex); // focus root folder
      }
      return;
    }

    if (type === 'bank' && index > 1) {
      // Middle of bank list — go to previous
      this.setFocusedIndex(index - 1);
      return;
    }

    if (type === 'bank' && index === 1) {
      // From first bank — go to folder
      this.setFocusedIndex(this.rootFolderIndex);
      return;
    }
  }

  private handleArrowRight(index: number, type: 'folder' | 'bank', banksLength: number): void {
    if (index === 0 && type === 'folder') {
      if (this.plusMinusSign === 1) {
        // Expand folder
        this.plusMinusSign = 0;
      } else if (banksLength > 0) {
        // Already expanded, move to first bank
        this.setFocusedIndex(1);
      }
    }
  }

  private handleArrowLeft(index: number, type: 'folder' | 'bank'): void {
    if (index === 0 && type === 'folder') {
      if (this.plusMinusSign !== 1) {
        // Folder is expanded → collapse it
        this.plusMinusSign = 1;
      }
    } else if (type === 'bank') {
      // On a bank → move focus back to folder
      this.setFocusedIndex(this.rootFolderIndex);
    }
  }

  private handleEnterOrSpace(index: number, type: 'folder' | 'bank', event: KeyboardEvent): void {
    if (type === 'folder' && index === this.rootFolderIndex) {
      // Toggle folder expansion
      this.toggleFolder();
    } else if (type === 'folder' && index === this.myQuestionsIndex) {
      // Select My Questions
      this.OnCheckboxSelect(this.sourceInfoData.sourceInfo.myquestions, this.sourceInfoData.sourceInfo.myquestions.title, event, this.myQuestionsIndex);
    } else if (type === 'bank') {
      // Select bank
      const bank = this.sourceInfoData.sourceInfo.banks[index - 1];
      this.OnCheckboxSelect(bank, bank.title, event, index - 1);
    }
  }

  // --- Focus Management ---
  private setFocusedIndex(index: number): void {
    this.focusedIndex = index;
    this.cdr.detectChanges();
    this.focusTreeItem(index);
  }

  private focusTreeItem(index: number): void {
    const treeItemsArray = this.treeItems?.toArray() || [];
    const treeItem = treeItemsArray.find(
      (el) => el.nativeElement.getAttribute('data-index') == String(index)
    );
    if (treeItem) {
      treeItem.nativeElement.focus();
    }
  }

  onInfoButtonKeydown(event: KeyboardEvent, index: number, bank: any, element: HTMLElement): void {
    const key = event.key;
    if (key === 'Enter' || key === ' ') {
      this.OnBankInfoSelect(true, bank.ezid, bank.title, bank.virtualBankId);
      return;
    }
    if (key === 'ArrowDown') {
      this.setFocusedIndex(index + 1);
      return;
    }
    if (key === 'ArrowUp') {
      this.setFocusedIndex(index - 1);
      return;
    }
    if (this.selectedBankObj) {
      this.focusedElement.emit(null);
    } else {
      this.focusedElement.emit(element);
    }
  }

  checkTooltipPresent(): boolean {
    return this.tooltipDirective.some(tooltip => tooltip.isOpen());
  }
}
